import LoadingButton from "@mui/lab/LoadingButton";
import React from "react";
import { COLOR_CONSTANTS } from "config/helpers/color_helper";

import { styled, useTheme } from "@mui/material/styles";
import { darken, lighten } from "@mui/system";
import { Tooltip } from "@mui/material";
import { CircularProgress } from "@mui/material";

const UIButton = (props) => {
  const theme = useTheme();
  const {
    loading = false,
    text = "Submit",
    callback = new Function(),
    disabled = false,
    loadingIndicator = "Please wait...",
    Icon = false,
    fullWidth = false,
    variant = "contained",
    sx = {},
    size = "medium",
    type = "button",
    padding = {
      topBottom: "6px",
      leftRight: "16px",
    },
    backgroundColor = "",
    btnColor = "",
    color = "primary",
    border = "",
    tooltip = "",
    customStyles = {},
  } = props;

  const secondaryStyles = backgroundColor
    ? {
        backgroundColor:
          variant === "contained"
            ? COLOR_CONSTANTS[backgroundColor.toUpperCase()] || backgroundColor
            : "transparent",
        color:
          variant === "outlined"
            ? COLOR_CONSTANTS[backgroundColor.toUpperCase()] || backgroundColor
            : COLOR_CONSTANTS[btnColor.toUpperCase()] || btnColor,
        border:
          variant === "outlined"
            ? `1px solid ${
                COLOR_CONSTANTS[backgroundColor.toUpperCase()] ||
                backgroundColor
              }`
            : COLOR_CONSTANTS[border.toUpperCase()] || border,
        "&:hover": {
          backgroundColor:
            variant === "outlined"
              ? lighten(
                  COLOR_CONSTANTS[backgroundColor.toUpperCase()] ||
                    backgroundColor,
                  0.95
                )
              : darken(
                  COLOR_CONSTANTS[backgroundColor.toUpperCase()] ||
                    backgroundColor,
                  0.15
                ),
          borderColor:
            variant === "outlined"
              ? lighten(
                  COLOR_CONSTANTS[backgroundColor.toUpperCase()] ||
                    backgroundColor,
                  0.3
                )
              : undefined,
          color:
            variant === "outlined"
              ? COLOR_CONSTANTS[backgroundColor.toUpperCase()] ||
                backgroundColor
              : undefined,
        },
      }
    : {};

  const getTooltip = () => {
    if (tooltip === true) {
      return text;
    } else if (tooltip?.length) {
      return tooltip;
    } else {
      return "";
    }
  };

  return (
    <Tooltip enterTouchDelay={0} disableInteractive title={getTooltip()}>
      <LoadingButton
        variant={variant}
        loading={loading}
        disabled={disabled}
        color={color}
        btnColor={btnColor}
        onClick={callback}
        size={size}
        fullWidth={fullWidth}
        type={type}
        startIcon={Icon ? Icon : <></>}
        sx={{ ...sx, ...secondaryStyles }}
        style={{
          padding: `${padding?.topBottom} ${padding?.leftRight}`,
          textTransform: "none",
          minWidth: 0,
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          minHeight: "3vh",
          ...customStyles,
        }}
        {...props}
      >
        {text}
      </LoadingButton>
    </Tooltip>
  );
};

export default UIButton;
